/* Blaq Budafli: safely sync the FREE digital planner with qualifying complete systems. */
(() => {
  if (window.__bbDigitalBonusLoaded) return;
  window.__bbDigitalBonusLoaded = true;

  const BONUS_VARIANT_ID = 49124539793562;
  const QUALIFYING_BUNDLES = new Set([35641188188314, 36266540335258]);
  const BONUS_PROPERTY = '_bb_free_bonus';
  let syncing = false;
  let syncTimer;

  function isBonusLine(item) {
    return Number(item.variant_id) === BONUS_VARIANT_ID && String(item.properties?.[BONUS_PROPERTY] || '') === '1';
  }

  function scheduleSync(delay = 500) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncDigitalBonus, delay);
  }

  async function requestCartSections(endpoint, payload) {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        ...payload,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    if (!response.ok) throw new Error('Unable to sync digital bonus');
    return response.json();
  }

  function redrawCart(data) {
    if (data?.sections) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.renderContents) {
        drawer.renderContents(data);
        return;
      }
    }
    if (window.location.pathname === '/cart') window.location.reload();
  }

  async function syncDigitalBonus() {
    if (syncing) return;
    syncing = true;
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to read cart');
      const cart = await response.json();
      const hasQualifyingBundle = cart.items.some(item => QUALIFYING_BUNDLES.has(Number(item.variant_id)));
      const bonusLines = cart.items.filter(isBonusLine);
      const bonusItem = bonusLines[0];

      /* A regularly purchased planner has no private bonus property and is never removed or altered here. */
      if (hasQualifyingBundle && !bonusItem) {
        const data = await requestCartSections('/cart/add.js', {
          items: [{ id: BONUS_VARIANT_ID, quantity: 1, properties: { [BONUS_PROPERTY]: '1' } }]
        });
        redrawCart(data);
        return;
      }

      if (hasQualifyingBundle && bonusItem && bonusItem.quantity !== 1) {
        const data = await requestCartSections('/cart/change.js', { id: bonusItem.key, quantity: 1 });
        redrawCart(data);
        return;
      }

      if (hasQualifyingBundle && bonusLines.length > 1) {
        for (const extra of bonusLines.slice(1)) {
          await requestCartSections('/cart/change.js', { id: extra.key, quantity: 0 });
        }
        if (window.location.pathname === '/cart') window.location.reload();
        return;
      }

      if (!hasQualifyingBundle && bonusLines.length) {
        let lastData;
        for (const line of bonusLines) {
          lastData = await requestCartSections('/cart/change.js', { id: line.key, quantity: 0 });
        }
        redrawCart(lastData);
      }
    } catch (error) {
      /* Never block shopping or checkout if the optional bonus sync cannot run. */
    } finally {
      syncing = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleSync(250), { once: true });
  } else {
    scheduleSync(100);
  }

  document.addEventListener('submit', event => {
    if (event.target?.matches('form[action*=\"/cart/add\"]')) scheduleSync(900);
  }, true);

  document.addEventListener('change', event => {
    if (event.target?.closest('cart-items, cart-drawer-items, form[action*=\"/cart\"]')) scheduleSync(900);
  }, true);

  document.addEventListener('click', event => {
    if (event.target?.closest('cart-remove-button, [href*=\"/cart/change\"], [data-cart-remove]')) scheduleSync(900);
  }, true);

  document.addEventListener('cart:updated', () => scheduleSync(150));
  document.addEventListener('cart-update', () => scheduleSync(150));

  const observer = new MutationObserver(() => {
    if (document.querySelector('cart-drawer.active')) scheduleSync(150);
  });
  observer.observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'] });
})();